import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {handleChange, toggleState} from 'utils/ComponentUtilFunctions';
import classNames from 'classnames';
import ShowPassIcon from 'assets/ShowPassIcon';
import {authenticate as authenticateApi, getEmail, logOperatorSession} from 'services/user/api';
import {getCookie} from "../../utils/CookieManager";
import config from "../../config";
import {Link} from "react-router-dom";
import BlueButton from "../../components-new/buttons/BlueButton";
import {getUserInfoFromToken} from "../../services/user/reducer";

class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            username: '',
            password: '',
            showPass: false,
            disabled: false,
            error: null,
        };

        this.handleChange = handleChange.bind(this);
        this.toggleState = toggleState.bind(this);
    }

    handleSubmit = async (event) => {
        event.preventDefault();
        const {disabled, username, password} = this.state;
        const {authenticate} = this.props;
        if (disabled) {
            return false;
        }
        this.setState({disabled: true});
        try {
            const emailResponse = await getEmail(username);
            await authenticateApi(emailResponse.data, password);
            const token = getCookie(config.jwtAuthToken);

            const userInfo = getUserInfoFromToken(token);
            try {
                await logOperatorSession({
                    operatorPlatformId: userInfo.id,
                    parentCompanyId: userInfo.companyId,
                    actionType: 'LOGIN',
                    userAgent: navigator.userAgent,
                });
            } catch (e) {
                console.error("Logging login failed", e);
            }

            authenticate(token);

        } catch (err) {
            this.setState({
                error: err,
            });
        } finally {
            this.setState({
                disabled: false,
            });
        }
        return false;
    };

    render() {
        const {
            username, password, showPass, error, disabled,
        } = this.state;
        return (
            <div className="login-content">
                <h1 style={{color: "#043e5c"}} className="form-header">
                    Sign-In
                </h1>
                <div className="app-login-form">
                    <form onSubmit={this.handleSubmit}>
                        <p className="form-element-label">
                            Username
                        </p>
                        <input
                            type="text"
                            className={classNames('form-element', {error})}
                            value={username}
                            autoComplete={'on'}
                            name={'username'}
                            onChange={this.handleChange('username')}
                        />
                        <p className="form-element-label">
                            Password
                        </p>
                        <div style={{position: 'relative'}}>
                            <input
                                type={showPass ? 'text' : 'password'}
                                className={classNames('form-element', {error})}
                                onChange={this.handleChange('password')}
                                name={'password'}
                                value={password}
                            />
                            <button
                                type="button"
                                style={{
                                    position: 'absolute',
                                    top: 0,
                                    right: 0,
                                    border: 'none',
                                    cursor: 'pointer',
                                    background: 'transparent',
                                    width: 50,
                                    height: 50,
                                    padding: '11px',
                                }}
                                onClick={this.toggleState('showPass')}
                            >
                                <ShowPassIcon show={showPass}/>
                            </button>
                        </div>
                        <p className={classNames('form-element-label', 'hide-on-error', {error})}>
                            Incorrect data
                        </p>
                        <BlueButton styles={{marginBottom:'5px'}} type={'submit'} children={'Sign-In'}/>
                        <div style={{textAlign: 'center'}}>
                            <Link to="/forgot" className="link">
                                <p className="link">
                                    Password recovery
                                </p>
                            </Link>
                        </div>
                    </form>
                </div>
            </div>
        );
    }
}

Login.propTypes = {
    authenticate: PropTypes.func,
};


export default Login;


// WEBPACK FOOTER //
// ./src/scenes/auth/Login.jsx